import { checkValidation } from "@/components/watchmen/check-validation";

function check_rules(channels) {
  const rulesStack = []
  const watchmen = listAllWatchmen(channels)
  const validations = listChannelsValidation(channels)
  const RULES_MAX = 3

  // Check rules
  if (hasAMobile(channels)) {
    rulesStack.push('one_mobile')
  }
  if (watchmen.length >= 2) {
    rulesStack.push('two_watchmen')
  }
  if (validations.includes(true)) {
    rulesStack.push('has_validated')
  }

  let status = ''
  let stepper_status = ''
  if (rulesStack.length === RULES_MAX) {
    status = 'complete'
    stepper_status = 'success'
  } else if (rulesStack.length === 0) {
    status = 'none'
    stepper_status = 'danger'
  } else {
    status = 'low'
    stepper_status = 'warning'
  }

  return {
    stepper_status: stepper_status,
    stack: rulesStack,
    rules_length: rulesStack.length,
    max: RULES_MAX,
    status: status,
    watchmen: watchmen,
  }
}

function listChannelsValidation (channels) {
  const channelsValidation = []
  for (const key in channels) {
    for (const channel of channels[key]) {
      channelsValidation.push(checkValidation(channel)[0])
    }
  }
  return channelsValidation
}

function hasAMobile(channels) {
  const channelsAcceptingPhones = []
  channels?.sms.forEach((item) => {
    channelsAcceptingPhones.push(item)
  })
  channels?.tts.forEach((item) => {
    channelsAcceptingPhones.push(item)
  })
  const mobile = channelsAcceptingPhones.filter((item) => item.type === 'mobile')

  return mobile.length > 0
}

function listAllWatchmen (channels) {
  const watchmen = []
  for (const key in channels) {
    for (const channel of channels[key]) {
      if (!watchmen.some(watchman => watchman.id === channel.watchman.id)) {
        watchmen.push(channel.watchman)
      }
    }
  }
  return watchmen
}

export { check_rules }